import * as yup from 'yup';
import {
  alternativeMedicineRequiredMessages,
  cannabisRequiredMessages,
  duplicateInvoiceError,
  maxCannabisReimbursementAmount,
} from 'Regex';
import { IInvoice } from 'Context/CannabisContext';

export const AlternativeMedicineSchema = (
  checkIfInvoiceExists: (invoiceNumber: string) => boolean
) =>
  yup.object().shape({
    invoiceId: yup
      .string()
      .required(alternativeMedicineRequiredMessages.number)
      .test(
        'isDuplicateInvoiceNumber',
        duplicateInvoiceError,
        (value) => !checkIfInvoiceExists(value || '')
      ),
    vendorName: yup
      .string()
      .nullable()
      .required(alternativeMedicineRequiredMessages.vendorName),
    invoiceDate: yup
      .date()
      .typeError(alternativeMedicineRequiredMessages.date)
      .nullable()
      .required(alternativeMedicineRequiredMessages.date),
    invoiceTotal: yup
      .number()
      .typeError(alternativeMedicineRequiredMessages.amount)
      .nullable()
      .max(
        maxCannabisReimbursementAmount,
        cannabisRequiredMessages.maxAmountError
      )
      .min(1, cannabisRequiredMessages.minAmountError)
      .required(alternativeMedicineRequiredMessages.amount),
    file: yup.mixed().nullable(),
  }) as yup.SchemaOf<IInvoice>;
